<template>
    <div class="my-2 py-2">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn color="primary" round class="white--text" @click="addFNO()">Link FNO</v-btn>
        </v-toolbar>
         <v-data-table :items="fnoList" :headers="headers" min-width="1000px"
         :rows-per-page-items="[25, 50, 100, 250]"
         :key="key"
      item-key="name"
      align-center
      style="cursor: pointer"
      disable-initial-sort
    >
      <template v-slot:items="props">
          <td class="text-xs-center">
            <v-chip color="light-green" class="white--text" v-if="props.item.isActive" @click="updateStatus(props.item)">Active</v-chip>
            <v-chip color="red" class="white--text" v-else @click="updateStatus(props.item)">Inactive</v-chip>
          </td>
          <td class="text-xs-center">
              {{props.item.networkProvider.name}}
          </td>
      </template>

        </v-data-table>
        <v-dialog v-model="addFnoModal" width="750px" persistent>
            <v-card>
                <v-toolbar flat color="primary" >
                    <h3 class="title white--text">Link FNO</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="addFnoModal=false, item={}">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout justify-center wrap>
                        <v-flex xs4 mx-1>
                            <v-autocomplete :items="allFnoList" label="FNO" item-text="name" item-value="id" v-model="item.networkProviderId"></v-autocomplete>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-switch label="Active Status" v-model="item.isActive" color="primary"></v-switch>
                        </v-flex>

                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-center>
                            <v-btn v-if="item.networkProviderId" round color="primary" @click="addFnoToVirtualNetwork(item)">Add Link</v-btn>
                            <v-btn v-else round color="primary" disabled >Add Link</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
export default {
    data(){
        return {
            addFnoModal: false,
            allFnoList: [],
            fnoList: [],
            item: {},
            key: 0,
            headers: [
                {
          text: "Status",
          align: "center",
          value: "isActive"
        },
        {
          text: "Name",
          align: "center",
          value: "networkProvider.name"
        }
            ]
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        async initialize(){
            await this.getFnoList()
            await this.getAllFno()
        },
        getFnoList(){
            Api().get('/virtualProviderNetworkOperator')
            .then(response=>{
                this.fnoList = response.data
            })
        },
        getAllFno(){
            Api().get('/organisationConnection')
            .then(response=>{
                let existingArray = this.fnoList.map(x=>x.networkProviderId)

                if(response.data.length>0){
          let result = response.data.map(x=>x.connectedOrganisation);
          this.allFnoList = result.filter(x=>!existingArray.includes(x.id))
          }
            })
        },
        addFNO(){
            if(this.authCreate(this.$store.state.currentRoute)){
            this.item={
                networkProviderId: null,
                isActive: false
            }
            this.addFnoModal = true
            }
        },
        addFnoToVirtualNetwork(item){
            Api().post('/virtualProviderNetworkOperator', item)
            .then(response=>{
                this.getFnoList()
                this.item = {}
                this.addFnoModal=false
            })
        },
        updateStatus(item){
            if(this.authUpdate(this.$store.state.currentRoute)){
Api().put('/virtualProviderNetworkOperator/'+item.id, {isActive: !item.isActive})
            .then(response=>{
                let index= this.fnoList.indexOf(this.fnoList.find(x=>x.id===item.id))
                this.fnoList[index].isActive = !item.isActive
            })
            }
        }
    }

    
}
</script>